'use strict';

import constants from '../../constants';

var beautyStationTabs = {
    init: function () {
        this.disableFoundationTabs();
        $(window).on('resize', this.disableFoundationTabs);
    },

    disableFoundationTabs: function () {
        var query = '(max-width:' + constants.SMALL_BREAKPOINT + ')';

        if (window.matchMedia(query).matches) {
            $('#beauty-station-tabs li').removeClass('tabs-title');
        } else {
            $('#beauty-station-tabs li').addClass('tabs-title');
        }
    }
};

export default beautyStationTabs;
